export default __webpack_public_path__ + "static/media/visa_PNG2.bdea89c6.png";